import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PartyTypes } from '@shared/party/enums';

@Component({
  selector: 'tablesready-party-type-badge',
  templateUrl: './party-type-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartyTypeBadgeComponent {
  @Input() type?: PartyTypes;
  @Input() confirmed?: number | null;
  @Input() reservationLabel = 'reservation';
  private readonly reservationLabels: {[key: string]: string} = {
    reservation: 'Res',
    appointment: 'Appt',
    booking: 'Book',
  };

  get label(): string {
    switch (this.type) {
      case PartyTypes.reservation:
        return this.reservationLabels[this.reservationLabel];

      case PartyTypes.walkIn:
        return 'Wal';

      case PartyTypes.togo:
        return 'ToGo';

      case PartyTypes.order:
        return 'Ord';

      default:
        return '';
    }
  }

  get tooltip() {
    switch (this.type) {
      case PartyTypes.reservation:
        return this.reservationLabel;

      case PartyTypes.walkIn:
        return 'Walk-in';

      case PartyTypes.togo:
        return 'To Go';

      case PartyTypes.order:
        return 'Order';

      default:
        return '';
    }
  }

  get classes(): string {
    const genericClasses = 'badge badge-pill';
    if (this.type === PartyTypes.reservation) {
      return `${genericClasses} ${this.confirmed ? 'badge-success' : 'badge-danger'}`;
    }

    return `${genericClasses} badge-success`;
  }
}
